var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meal-tab"},_vm._l((_vm.options),function(item,index){return _c('span',{key:index,staticClass:"item",class:{active: _vm.value == index},style:({width: (100 / _vm.options.length) + '%'}),on:{"click":function($event){_vm.click(index)}}},[_vm._v(_vm._s(item.type))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-760b2eba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/loader.js!./src/components/global/mealtabs.vue
// module id = fHYu
// module chunks = 30